import { ChangeDetectionStrategy, Component, HostBinding } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { LoginFormComponent } from '@spartacus/user/account/components';
import { UigLoginFormComponentService } from './uig-login-form-component.service';
import { Subscription } from 'rxjs/internal/Subscription';
import { filter } from 'rxjs/internal/operators/filter';
import { map } from 'rxjs/operators';
import { UigB2BUser } from 'src/app/organization/uig-user/uig-user.model';
import { UserAccountService } from '@spartacus/user/account/core';
import { GlobalMessageService, GlobalMessageType, RoutingService } from '@spartacus/core';
import { CustomVendorReportingUtils } from 'src/app/uig-my-account/custom-vendor-reporting/custom-vendor-reporting-utils';



@Component({
    selector: 'app-uig-login-form',
    templateUrl: './uig-login-form.component.html',
    styleUrls: ['./uig-login-form.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class UigLoginFormComponent extends LoginFormComponent {
  private readonly wrongCmsSiteMessageStorageKey = 'uig.wrongCmsSiteMessage';

  constructor(
    private loginFormComponentService: UigLoginFormComponentService,
    private router: RoutingService,
    private userService: UserAccountService,
    private globalMessageService: GlobalMessageService
  ) {
    super(loginFormComponentService);
  
  }

  @HostBinding('class.user-form') style = true;
  subscription = new Subscription();

  ngOnInit(): void {
    this.showQueuedWrongCmsSiteMessage();
  }


  onSubmit(): void {
    super.onSubmit();
    this.subscription.add(
      this.userService
        .get()
        .pipe(
          filter((user: UigB2BUser) => user?.orgUnit !== undefined),
          map((user) => user?.orgUnit?.uid)
        )
        .subscribe((unitId) => {
          if (unitId === CustomVendorReportingUtils.rioEmployeeB2BUnit) {
            this.router.go({
              cxRoute: 'rioDashboard',
            });
          }
        })
    );
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  private showQueuedWrongCmsSiteMessage(): void {
    try {
      const rawMessage = window.sessionStorage.getItem(
        this.wrongCmsSiteMessageStorageKey
      );

      if (!rawMessage) {
        return;
      }

      const payload = JSON.parse(rawMessage) as { shopName?: string };
      if (payload?.shopName) {
        this.globalMessageService.add(
          {
            key: 'httpHandlers.wrongCmsSiteError',
            params: { shopName: payload.shopName },
          },
          GlobalMessageType.MSG_TYPE_ERROR
        );
      }

      window.sessionStorage.removeItem(this.wrongCmsSiteMessageStorageKey);
    } catch {
      window.sessionStorage.removeItem(this.wrongCmsSiteMessageStorageKey);
    }
  }
}
